var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass},[_c('a',{class:_vm.linkClass,staticStyle:{"cursor":"pointer"},on:{"click":_vm.openWhatsAppModal}},[_c('img',{attrs:{"src":"/whatsapp.svg","width":"30px","height":"30px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }